function toggleCart() {
  const container = document.querySelector("#CartContainer");
  if (container.classList.contains("is-open")) {
    container.querySelector(".cart").style.transform = "translateX(100%)";
    setTimeout(() => {
      container.classList.remove("is-open");
      document.body.style.overflow = "";
      document.body.classList.remove("upcartPopupShow");
    }, 350);
  } else {
    container.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      container.querySelector(".cart").style.transform = "translateX(0%)";
    }, 0);
  }
}

let upgradeFromVariantId = "";
let upgradeBlock = null;

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = "hidden";
  }, 500);
  window.removeEventListener("transitionend", bodyOverflow);
}

let productObserver = null;
let hasSetupListener = false;

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector("#AddToCart").onclick = () => {
    console.log("add cart");
    const id = document.querySelector('select[name="id"]').value;

    CartJS.addItem(id, 1);
  };
  if (document.querySelector("#AddToCart")) {
    productObserver = new MutationObserver((mutations) => {
      if (!hasSetupListener) {
        let baseAddToCart = [];

        document.querySelector("#AddToCart").onclick = () => {
          if ( document.querySelector("#AddToCart").getAttribute("disabled") === "disabled" ) {
            return;
          }
          const id = document.querySelector('select[name="id"]').value;
          const name = document.querySelector('.product-details-product-title').textContent + ' - ' + document.querySelector('select[name="id"] option:checked').textContent.split(' -')[0]
;
          const radio = document.querySelector("#bold_options_div input[type=radio]");

          if (document.querySelector("#bold_options_div") && radio?.checked) {
            const boldEle = document.querySelector("#bold_options_div .bold_option_textbox input");

            var warningElement = document.getElementById("tempWarning");
            if (warningElement) {
              warningElement.remove();
            }
            
            if (!boldEle.value) {
              var boldOptionElement = document.querySelector(
                ".bold_option_textbox .bold_option_element"
              );
              var spanElement = document.createElement("span");
              spanElement.textContent = "Please enter initials";
              spanElement.style.color = "#ad0000";
              spanElement.id = "tempWarning";
              boldOptionElement.appendChild(spanElement);
              
              if( boldOptionElement.closest('.product-extension-item__product-inner-bottom') ) {
                var content = boldOptionElement.closest('.product-extension-item__product-inner-bottom');
                setTimeout(function(){
                  content.style.height = $(content).find('#bold_options_div').outerHeight(true) + "px";
                  content.style.maxHeight = $(content).find('#bold_options_div').outerHeight(true) + "px";
                },5);
              }

              return;
            }

            baseAddToCart = [
              {
                id,
                quantity: 1,
                //[radio.getAttribute('name')]: radio.value,
                //[boldEle.getAttribute('name')]: boldEle.value,
                properties: {
                  'Has Monogramming': 'Yes',
                  'Initials (Capital letters only)*': boldEle.value,
                },
                //['properties[Has Monogramming]']: 'Yes',
                //[boldEle.getAttribute('name')]: boldEle.value,
              },
              {
                id: document.querySelector('input[name="properties[_boldVariantIds]"]').value,
                properties: {
                  'Initials (Capital letters only)*': boldEle.value,
                  'Key Organiser': name,
                },
                //[boldEle.getAttribute('name')]: boldEle.value,
                //['properties[Key Organiser]']: name
              }
            ];
            if (document.querySelector('input[name="properties[PreOrder]"]') && document.querySelector('input[name="properties[PreOrder]"]').value) {
              baseAddToCart[0].properties = {
                'PreOrder': document.querySelector('input[name="properties[PreOrder]"]').value,
              };
            }

          } else {
            baseAddToCart = [
              {
                id,
                quantity: 1,
              },
            ]
            if (document.querySelector('input[name="properties[PreOrder]"]') && document.querySelector('input[name="properties[PreOrder]"]').value) {
              baseAddToCart[0].properties = {
                'PreOrder': document.querySelector('input[name="properties[PreOrder]"]').value,
              };
            }
          }

          let productFreeGift = document.querySelector("product-free-gift");
          if (productFreeGift) {
            baseAddToCart.push({
              id: productFreeGift.getAttribute("data-gift-id"),
              quantity: 1,
            });
          }
              // CHECK AND ADD SELECTED EXTENSION TO CART
              var extensionProducts = document.querySelectorAll('.product-extension-item__product-variant.selected:not(.product-extension-item__product-variant-none');
              extensionProducts.forEach(function(extensionProduct){
                var variantID = extensionProduct.getAttribute('data-variant');
                //console.log(variantID);
                if (variantID) {
                  baseAddToCart.push({
                    id: variantID,
                    quantity: 1
                  })
                }
              });

          CartJS.addItems(baseAddToCart);
        };
      }
    });

    productObserver.observe(document.querySelector(".main-content"), {
      subtree: true,
      childList: true,
      attributes: true,
    });
  }

  document.querySelectorAll([".cart__underlay", ".close-cart"]).forEach((item) => item.addEventListener("click", (event) => {
        console.log("add cart toggle");
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleCart();
      })
    );
});

if (!customElements.get("open-cart")) {
  customElements.define(
    "open-cart",
    class OpenCart extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("click", () => {
          toggleCart();
        });
      }
    }
  );
}

if (!customElements.get("cart-item")) {
  customElements.define(
    "cart-item",
    class CartItem extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".price-remove .remove").addEventListener(
          "click",
          (event) => {
            event.target.classList.add("free-gift-loading");

            CartJS.removeItem(
              event.target.closest("cart-item").getAttribute("data-line")
            );
          }
        );

        this.querySelector(".qty-wrapper .minus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepDown();
            this.updateQuantity();
          }
        );
        this.querySelector(".qty-wrapper .plus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepUp();
            this.updateQuantity();
          }
        );
      }

      timeout = null;

      updateQuantity() {
        if (this.timeout) {
          return;
        }

        this.timeout = setTimeout(() => {
          this.querySelector(".price-remove .remove").classList.add(
            "free-gift-loading"
          );
          CartJS.updateItem(
            this.getAttribute("data-line"),
            this.querySelector("input").value
          );
          this.timeout = null;
        }, 300);
      }
    }
  );
}

if (!customElements.get("cart-header")) {
  customElements.define(
    "cart-header",
    class CartHeader extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".close-cart").addEventListener("click", (event) => {
          toggleCart();
        });
      }
    }
  );
}


let previousCartState = null;
// Fetch the current cart data
function fetchCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(currentCart => {
      if (previousCartState) {
        checkForRemovedItems(previousCartState, currentCart);
      }
      previousCartState = currentCart; // Update the previous cart state
    });
}

// Compare the previous cart with the current one to find removed items
function checkForRemovedItems(prevCart, currCart) {
  const prevItems = prevCart.items.map(item => item.key);
  const currItems = currCart.items.map(item => item.key);

  // Find the item(s) removed by comparing the two arrays
  const removedItems = prevItems.filter(key => !currItems.includes(key));
  if (removedItems.length > 0) {
    removedItems.forEach(removedItem => {
      // Find the full item details by variant_id from the previous cart
      const removedItemDetails = prevCart.items.find(item => item.key === removedItem);
      if (removedItemDetails.properties['Has Monogramming'] == 'Yes') {
        // KO with Monogramming removed
        const propertiesToRemove = {
          'Key Organiser': removedItemDetails.title,
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        removeItemByProperties(propertiesToRemove);
      } else if (removedItemDetails.properties['Initials (Capital letters only)*'] != '') {
        // Monogramming removed
        const propertiesToRemove = {
          'Has Monogramming': 'Yes',
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        const newProperties = {
          'Has Monogramming': 'No',
        }; // Clear old properties
        updateItemProperties(propertiesToRemove,newProperties);
      }
    });
  }
}

// Poll the cart periodically to detect changes
setInterval(fetchCart, 5000);

function updateItemProperties(properties,newProperties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach((item,index) => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });

        // If all properties match, remove the item's properties
        if (matchesAllProperties) {
          //console.log(item);
          updateCartItemProperties(item.key, newProperties)
          setTimeout(function(){
            CartJS.updateItem(index+1, item.quantity);
          },1000);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

function removeItemByProperties(properties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach(item => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });
        // If all properties match, remove the item
        if (matchesAllProperties) {
          //console.log(item);
          CartJS.removeItemById(item.key);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Remove the item from the cart by variant ID or line ID
function updateCartItemProperties(key, properties) {
  let data = {
      "id" : key,
      "properties" : properties
  }
  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}

// Remove the item from the cart by variant ID or line ID
function removeCartItem(key) {
  let data = {
      "id" : key,
      "quantity" : 0
  }
  console.log(data);

  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}
